import { collection, doc, getDoc, getDocs } from "firebase/firestore";
import React, { useEffect, useState } from "react";
import { Button, Navbar, Table } from "react-bootstrap";
import Moment from "react-moment";
import { Link, useNavigate } from "react-router-dom";
import db from "../../Firebase/config";
import SideNav from "../SideNav/SideNav";
import "./dashboard.css";

const Dashboard = () => {
  const [complaints, setComplaints] = useState([]);
  const [loading, setLoading] = useState(false);
  let navigate = useNavigate();

  // const fetchComplaints = async () => {
  //   const response = db.collection("complaints");
  //   const data = await response.get();
  //   data.docs.forEach((item) => {
  //     setComplaints([...complaints, item.data()]);
  //   });
  // };

  // useEffect(() => {
  //   fetchComplaints();
  // }, []);

  useEffect(() => {
    async function fetchComplaints() {
      const data = [];
      const querySnapshot = await getDocs(collection(db, "complaints"));
      querySnapshot.forEach((doc) => {
        data.push(doc.data());
        //console.log(doc.data());
      });
      setComplaints(data);
    }
    fetchComplaints();
  }, []);
  // console.log("complaints:", complaints);
  // console.log("type", typeof complaints);

  if (loading) return <p>Fetching complaints...</p>;
  if (!loading && complaints.length === 0)
    return <p>Sorry, no complaints yet</p>;

  return (
    <div className="app">
      <div className="app-left">
        <SideNav />
      </div>
      <div className="app-right">
        <Navbar />
        <div className="dashboard">
          <div className="dashboard-body">
            <div className="dashboard-top">
              <h2>Complaints Dashboard</h2>{" "}
              <div className="complaint-btn">
                <Button
                  onClick={() => navigate("/")}
                  variant="success"
                  style={{
                    padding: "10px 20px",
                    fontWeight: "bold",
                  }}
                >
                  Make A Complaint
                </Button>
              </div>
            </div>

            <div className="dashboard-table">
              <Table striped bordered hover size="sm">
                <thead>
                  <tr>
                    <th>Location</th>
                    <th>Category</th>
                    <th>Complaint Type</th>
                    <th>Status</th>
                    <th>Date</th>
                    <th>Complaint</th>
                  </tr>
                </thead>
                <tbody>
                  {Object.values(complaints).map((complaint, idx) => (
                    <tr key={idx} className="complaints">
                      <td>{complaint.location.toString()}</td>
                      <td>{complaint.categorie.toString()}</td>
                      <td>{complaint.complaintType.toString()}</td>
                      <td>sent</td>
                      <td>{complaint.timestamp.toString()}</td>
                      <td>
                        <Button
                          size="sm"
                          variant="success"
                          style={{ padding: 0, padding: "2px 10px" }}
                        >
                          <Link to="/status" state={{ complaint }}>
                            View Complaint
                          </Link>
                        </Button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Dashboard;
